module.exports = __webpack_public_path__ + "img/home.6e122744.png";